<script>
import appbarMixin from '@/v-shop/mixins/appbarMixin'

export default {
	mixins: [appbarMixin],
	data() {
		return {
			currentIdx: 0,
			autoplayInterval: null,
			resetTimeout: null,
			isTransitioning: false,
		}
	},
	computed: {
		topMsgConfig() {
			return this.$srv('appbarTopMessage')?.find(
				(config) =>
					!config.device ||
					config.device == 'x' ||
					this.$b({ mt: config.device == 'm', d: config.device == 'd' })
			)
		},
		autoplayDuration() {
			return this.topMsgConfig?.slideTimer || 4000
		},
		animationDuration() {
			return this.topMsgConfig?.animationDuration || 3500
		},
		showTopAppBar() {
			if (!this.$srv('AppBarConfig.showTopNavbar')) {
				return false
			}
			return this.topMsgConfig
		},
		slides() {
			return this.topMsgConfig?.slides?.filter(Boolean) || []
		},
		hasCarousel() {
			return this.topMsgConfig?.useCarousel && this.slides.length > 1
		},
		carouselSlides() {
			return this.hasCarousel ? [...this.slides, this.slides[0]] : this.slides
		},
	},
	methods: {
		startAutoplay() {
			if (this.autoplayInterval || !this.hasCarousel) return
			this.autoplayInterval = setInterval(this.nextSlide, this.autoplayDuration)
		},
		nextSlide() {
			if (this.isTransitioning || !this.hasCarousel) return

			this.isTransitioning = true
			this.currentIdx++

			if (this.currentIdx >= this.slides.length) {
				this.resetTimeout = setTimeout(() => {
					this.currentIdx = 0
					this.resetTimeout = null
					this.isTransitioning = false
				}, this.animationDuration)
			} else {
				this.resetTimeout = setTimeout(() => {
					this.resetTimeout = null
					this.isTransitioning = false
				}, this.animationDuration)
			}
		},
		handleVisibilityChange() {
			if (document.hidden) {
				this.stopAutoplay()
				this.autoplayInterval = null
			} else if (!this.autoplayInterval) {
				this.startAutoplay()
			}
		},
		stopAutoplay() {
			if (this.autoplayInterval) {
				clearInterval(this.autoplayInterval)
				this.autoplayInterval = null
			}
		},
		clearResetTimeout() {
			if (this.resetTimeout) {
				clearTimeout(this.resetTimeout)
				this.resetTimeout = null
			}
		},
		handleMouseEnter() {
			this.stopAutoplay()
		},
		handleMouseLeave() {
			this.startAutoplay()
		},
	},
	mounted() {
		if (this.hasCarousel) {
			document.addEventListener('visibilitychange', this.handleVisibilityChange) // handle browser tab visibility change
			this.startAutoplay()
		}
	},
	beforeDestroy() {
		this.stopAutoplay()
		this.clearResetTimeout()
		document.removeEventListener('visibilitychange', this.handleVisibilityChange)
	},
}
</script>

<template>
	<div v-if="showTopAppBar" ref="slideContainer" class="appbar-top-msg secondary d-flex align-center">
		<div
			v-if="hasCarousel"
			class="w100 secondary d-flex align-center"
			@mouseenter="handleMouseEnter"
			@mouseleave="handleMouseLeave"
			:style="{
				transform: `translateX(-${currentIdx * 100}%)`,
				transition: isTransitioning ? `transform ${animationDuration}ms ease-in-out` : 'none',
			}"
		>
			<AppBar-TopMsg-Item
				v-for="(slide, n) in carouselSlides"
				:key="n"
				class="appbar-top-msg__content w100 flex-shrink-0"
				:slide="slide"
			/>
		</div>
		<AppBar-TopMsg-Item v-else class="w100" :slide="topMsgConfig" />
	</div>
</template>

<style scoped lang="scss">
.appbar-top-msg {
	transition: transform 3.5s ease-in-out;
}
</style>

